module.exports = __webpack_public_path__ + "static/nav-contact-4-8a29b0ffe29a7ab4f6507c24bbbefa94.jpg";